const messages: Record<string, string> = {
  EMPLOYEE_NOT_FOUND: 'Employee was not found.',
  EMPLOYEE_NOT_ACTIVE: 'This employee is not active.',
  FACE_ATTENDANCE_NOT_ENABLED: 'Face attendance is not enabled for this employee.',
  AZURE_PERSON_GROUP_NOT_READY: 'Face registration is not currently available.',
  AZURE_PERSON_NOT_CONFIGURED: 'Start face registration first.',
  AZURE_PERSON_MAPPING_MISSING: 'The face registration is not synchronized.',
  AZURE_PERSON_CREATION_FAILED: 'Face registration could not be started.',
  AZURE_PERSON_LOCAL_SAVE_FAILED: 'Face registration could not be saved.',
  AZURE_FACE_RATE_LIMITED: 'Face services are busy. Try again shortly.',
  AZURE_FACE_TIMEOUT: 'Face services took too long. Try again.',
  AZURE_FACE_UNAVAILABLE: 'Face services are temporarily unavailable.',
  AZURE_FACE_DISABLED: 'Face services are temporarily unavailable.',
  AZURE_FACE_CONFIGURATION_ERROR: 'Face services are temporarily unavailable.',
  AZURE_FACE_AUTHENTICATION_FAILED: 'Face services are temporarily unavailable.',
  AZURE_FACE_INVALID_REQUEST: 'Face registration could not be loaded. Try again.',
  BIOMETRIC_PROVIDER_UNAVAILABLE: 'Face registration is not available right now.',
  BIOMETRIC_RESOURCE_NOT_FOUND: 'Face registration is not configured for this organization.',
  FACE_IMAGE_REQUIRED: 'A face image is required.',
  FACE_IMAGE_INVALID: 'The face image could not be used. Capture again.',
  FACE_IMAGE_TOO_SMALL: 'The face image is too small. Capture again.',
  FACE_IMAGE_TOO_LARGE: 'The face image is too large. Capture again.',
  FACE_IMAGE_TYPE_NOT_SUPPORTED: 'That image type is not supported.',
  FACE_SAMPLE_LIMIT_REACHED: 'The maximum number of samples has been reached.',
  FACE_SAMPLE_LOCAL_SAVE_FAILED: 'The face sample could not be saved.',
  AZURE_FACE_ENROLLMENT_FAILED: 'The face sample could not be enrolled.',
  AZURE_PERSON_GROUP_NOT_TRAINED: 'Face registration training is not complete.',
  AZURE_TRAINING_FAILED: 'Face registration training failed.',
  AZURE_TRAINING_TIMEOUT: 'Training took too long. Check status and try again.',
  AZURE_FACE_DEREGISTRATION_FAILED:
    'Face registration removal could not be completed.',
  FACE_REGISTRATION_NOT_FOUND: 'Face registration was not found.',
  FACE_DEREGISTRATION_NOT_RETRYABLE: 'Face removal cannot be retried right now.',
  FACE_NOT_DETECTED: 'Center one clear face in the frame and try again.',
  MULTIPLE_FACES_DETECTED: 'Only one person should be in the frame.',
  FACE_QUALITY_TOO_LOW: 'Improve lighting and hold steady, then try again.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The request timed out.',
  ACCESS_DENIED: 'You do not have permission for this action.',
};

export function faceRegistrationErrorMessage(code?: string | null, fallback?: string) {
  if (code && messages[code]) return messages[code];
  return fallback ?? 'Face registration is temporarily unavailable.';
}
